import { pageInfo, uploadSealImg, uploadAttach, attachDetail, deleteBatch, batchDownloadSealImg, batchDownloadAttach, shiptoByDc, viewSealImg } from './../api';
import { getDcNoList } from '../../../../api/selects'
const shipToSeal = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    attachDetailList: null,
    sealImgList: null,
    shiptoOptionsList: null,
    dcNoListData: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    ATTACH_DETAIL(state, data) {
      state.attachDetailList = data.obj || [];
    },
    VIEW_SEAL_IMG(state, data) {
      state.sealImgList = data.obj || [];
    },
    SHIPTO_BY_DC(state, data) {
      state.shiptoOptionsList = data.obj || [];
    },
    DC_NO_LIST(state, data) {
      state.dcNoListData = data;
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async uploadSealImg({ commit }, obj) {
      let resp = await uploadSealImg(obj);
      return resp;
    },
    async uploadAttach({ commit }, obj) {
      let resp = await uploadAttach(obj);
      return resp;
    },
    async attachDetail({ commit }, obj) {
      let resp = await attachDetail(obj);
      commit('ATTACH_DETAIL', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      return resp;
    },
    async batchDownloadSealImg({ commit }, obj) {
      let resp = await batchDownloadSealImg(obj);
      return resp;
    },
    async batchDownloadAttach({ commit }, obj) {
      let resp = await batchDownloadAttach(obj);
      return resp;
    },
    async shiptoByDc({ commit }, obj) {
      let resp = await shiptoByDc(obj);
      commit('SHIPTO_BY_DC', resp);
    },
    async viewSealImg({ commit }, obj) {
      let resp = await viewSealImg(obj);
      commit('VIEW_SEAL_IMG', resp);
    },
    async dcNoList({ commit }, obj) {
      let resp = await getDcNoList(obj);
      commit('DC_NO_LIST', resp);
    },
  }
}
export default shipToSeal



// WEBPACK FOOTER //
// ./src/page/md/shipToSeal/store/shipToSeal.store.js